import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledSliderNavProps } from './Slider.types';
import { IStyledDot, ISliderDots } from './SliderDots.types';
import { IStyledProgressBarProps } from './SliderProgressBar.types';

export const StyledWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const StyledNav = styled.nav<IStyledSliderNavProps>`
  display: none;
  width: 100%;
  justify-content: flex-end;
  z-index: 2;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
  }

  ${({ listing }) =>
    listing
      ? `
    position: absolute;
    top: 50%;
    justify-content: space-between;
    transform: translateY(-50%);
  `
      : `
  &:not(:empty) {
    padding-bottom: ${rem('16px')};
  }
  `}
`;

export const StyledNavButton = styled.button<IStyledSliderNavProps>`
  height: ${rem('24px')};
  width: ${rem('24px')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${rem('5px')};
  border: none;
  background: transparent;
  appearance: none;
  cursor: pointer;

  ${({ listing, theme }) =>
    listing && {
      margin: rem('8px'),
      borderRadius: rem('16px'),
      background: theme.colors.main,
      boxShadow: `0 0 ${rem('2px')} 0 rgba(0, 0, 0, 0.25)`,
    }}

  & svg {
    width: ${rem('11px')};
    height: auto;
  }

  &:nth-child(1) {
    svg {
      transform: rotate(90deg);
    }
  }

  &:nth-child(2) {
    svg {
      transform: rotate(-90deg);
    }
  }

  &:focus {
    outline: none; //TODO add proper focus style
  }

  &[aria-disabled='true'] {
    opacity: 0.4;
    cursor: default;
  }
`;

export const StyledDotsWrapper = styled.div<ISliderDots>`
  width: 100%;
  position: absolute;
  bottom: ${rem('8px')};
  ${({ listing }) =>
    listing && {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: '0',
      height: rem('33px'),
      background: `linear-gradient(180deg,
    transparent 0%,
    rgba(0, 0, 0, 0.02) 25%,
    rgba(0, 0, 0, 0.07) 50%,
    rgba(0, 0, 0, 0.15) 75%,
    rgba(0, 0, 0, 0.25) 100%
  )`,
    }}
`;

export const StyledDotList = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
`;

export const StyledDot = styled.li<IStyledDot>`
  margin: ${rem('4px')};
  border-radius: 100%;
  list-style: none;

  ${({ active, alternate, theme, user, listing }) =>
    active
      ? `
    height: ${rem('10px')};
    width: ${rem('10px')};
    background-color: ${
      user ? theme.colors[user].main : listing && theme.colors.main
    };
  `
      : `
    height: ${rem('8px')};
    width: ${rem('8px')};
    background-color: ${
      alternate ? theme.colors.cross.silverFox : theme.colors.main
    };
    background-color: ${listing && theme.colors.cross.silverFox};
  `}
`;

export const StyledProgressBar = styled.div<IStyledProgressBarProps>`
  display: flex;
  width: ${({ progress }) => `${progress}%`};
  height: ${rem('4px')};
  background: ${({ theme }) => theme.colors.gradients.main};
`;
